module.exports = __webpack_public_path__ + "static/img/OM1.2682d09a.png";